interface BarItem {
  label: string;
  value: number;
  color?: string;
}

interface HorizontalBarChartProps {
  data: BarItem[];
  maxValue?: number;
}

const defaultColors = ['#57a6d8', '#2fbc80', '#8d82bc', '#eb6587', '#f6c23e'];

export function HorizontalBarChart({ data, maxValue }: HorizontalBarChartProps) {
  const max = maxValue ?? Math.max(...data.map((d) => d.value), 1);

  return (
    <div className="space-y-3">
      {data.map((item, index) => {
        const widthPercent = Math.min((item.value / max) * 100, 100);
        const barColor = item.color ?? defaultColors[index % defaultColors.length];

        return (
          <div key={item.label} className="flex items-center gap-3">
            <span className="w-32 shrink-0 truncate text-sm text-gray-700 text-right">
              {item.label}
            </span>
            <div className="flex-1 h-6 rounded bg-gray-100 overflow-hidden">
              <div
                className="h-full rounded transition-all duration-300"
                style={{ width: `${widthPercent}%`, backgroundColor: barColor }}
              />
            </div>
            <span className="w-12 shrink-0 text-sm font-medium text-gray-700 text-right">
              {item.value}
            </span>
          </div>
        );
      })}
    </div>
  );
}
